module.exports = __webpack_public_path__ + "img/terroir-bright-2-mobile.1420ebc2.jpg";